module.exports = __webpack_public_path__ + "007f110437a3e1f6c6f1a696c1b6bacd.png";